import React, { useState } from 'react';
import { Alert, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, Row, Button, Spinner } from 'reactstrap';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import Api from '../../api/api';

const LuminousRewardsPage = () => {
    const [address, setAddress] = useState('');
    const [rewardData, setRewardData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleAddressChange = (event) => {
        setAddress(event.target.value);
    };

    const fetchLuminousRewards = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await Api.get(`luminous-rewards/${address}`);
            if (response.error) {
                throw new Error(response.error);
            }
            setRewardData(response.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        fetchLuminousRewards();
    };

    return (
        <Container className="pt-5">
            <Row className="justify-content-center">
                <Col md="8">
                    <Card>
                        <CardHeader>
                            <h5>Luminous Rewards</h5>
                        </CardHeader>
                        <CardBody>
                            <Form onSubmit={handleSubmit}>
                                <FormGroup>
                                    <Label for="address">Address</Label>
                                    <Input
                                        type="text"
                                        id="address"
                                        value={address}
                                        onChange={handleAddressChange}
                                        placeholder="Enter the wallet address"
                                        required
                                    />
                                </FormGroup>
                                <Button color="primary" type="submit" disabled={loading}>
                                    {loading ? <Spinner size="sm" /> : 'Fetch Data'}
                                </Button>
                            </Form>
                            {error && <Alert color="danger" className="mt-3">{error}</Alert>}
                            {rewardData && (
                                <div className="mt-4">
                                    <h6>Reward Details:</h6>
                                    <p><strong>Balance:</strong> {(parseFloat(rewardData.reward.balance) / 1e9).toFixed(3)} LIGHT</p>
                                    <p><strong>Reward:</strong> {(parseFloat(rewardData.reward.reward) / 1e9).toFixed(3)} LIGHT</p>
                                    <h6>Reward Logs:</h6>
                                    <ResponsiveContainer width="100%" height={300}>
                                        <LineChart data={rewardData.rewardLogs.reverse().map(log => ({
                                            ...log,
                                            created: new Date(log.created).toLocaleDateString(),
                                        }))}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="created" />
                                            <YAxis />
                                            <Tooltip />
                                            <Line type="monotone" dataKey="amount" stroke="#8884d8" />
                                        </LineChart>
                                    </ResponsiveContainer>
                                    <ul className="list-unstyled mt-3">
                                        {rewardData.rewardLogs.map(log => (
                                            <li key={log.id} className="border-bottom pb-2 pt-2">
                                                <strong>Operation:</strong> {log.operation} - <strong>Amount:</strong> {log.amount} - <strong>Date:</strong> {new Date(log.created).toLocaleString()}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default LuminousRewardsPage;
